import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useRouteMatch, useLocation } from 'react-router-dom';
import NotFound from '../Error/NotFound';
import { buildTransferLinkAuto } from '../../helpers/transfer';
import { selectUkiCustomerId } from '../../store/modules/user/selectors';
import { selectIsLoggedIn } from '../../store/modules/auth/selectors';

const Transfer = ({ isLoggedIn, isV2Customer }) => {
    const { app } = useRouteMatch().params;
    const location = useLocation();
    const trimFromPath = `/transfer/${app}`.length;

    const url = buildTransferLinkAuto(
        app,
        `${location.pathname.substr(trimFromPath)}${location.search}${
            location.hash
        }`,
        isLoggedIn,
        isV2Customer,
        null
    );

    if (!url) {
        return <NotFound />;
    }

    window.location.href = url;
    return null;
};

const mapStateToProps = state => ({
    isLoggedIn: selectIsLoggedIn(state),
    isV2Customer: !!selectUkiCustomerId(state)
});

Transfer.defaultProps = {
    isLoggedIn: false,
    isV2Customer: false
};

Transfer.propTypes = {
    isLoggedIn: PropTypes.bool,
    isV2Customer: PropTypes.bool
};

export default connect(mapStateToProps)(Transfer);
